export default "__VITE_ASSET__812dd2fa__"